module.exports = (theme) => ({
  /** Container for responsive background image switching. */
  ".responsive-background-image-container": {
    "@apply ds-relative ds-flex ds-flex-col ds-justify-center ds-items-center": 1,
  },

  /** Base styles for background image elements. Hidden by default */
  ".responsive-background-image": {
    "@apply ds-absolute ds-inset-0 ds-bg-cover ds-bg-no-repeat ds-bg-center ds-hidden": 1,
  },

  /** Non-overlapping screen ranges for when to display background image elements */
  [`@media (width < ${theme("screens.sm")})`]: {
    ".responsive-background-image-sm": { "@apply ds-block": 1 },
  },
  [`@media (${theme("screens.sm")} <= width < ${theme("screens.lg")})`]: {
    ".responsive-background-image-md": { "@apply ds-block": 1 },
  },
  [`@media (width >= ${theme("screens.lg")})`]: {
    ".responsive-background-image-lg": { "@apply ds-block": 1 },
  },
});
